import { Component } from "react";

export class SacredAdminErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen py-24 px-4 bg-red-50 text-red-900">
          <div className="max-w-lg mx-auto">
            <h1 className="text-xl font-semibold mb-2">Sacred Admin failed to load</h1>
            <p className="text-sm mb-4">{String(this.state.error?.message || this.state.error)}</p>
            <button
              type="button"
              className="underline text-sm"
              onClick={() => window.location.reload()}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
